import type { ChildContainerProps, LayoutContextProps, LayoutConfig, LayoutState, Breadcrumb, ColorScheme } from 'types/index';
import React, { useEffect, useState } from 'react';

export const LayoutContext = React.createContext({} as LayoutContextProps);

export const LayoutProvider = (props: ChildContainerProps) => {
    const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);

    // const [layoutConfig, setLayoutConfig] = useState<LayoutConfig>({
    //     ripple: true,
    //     inputStyle: 'outlined',
    //     menuMode: 'slim',
    //     colorScheme: 'light',
    //     componentTheme: 'indigo',
    //     scale: 14,
    //     menuTheme: 'light',
    //     topbarTheme: 'indigo',
    //     menuProfilePosition: 'end',
    //     desktopMenuActive: true,
    //     mobileMenuActive: false,
    //     mobileTopbarActive: false
    // });

    const [layoutConfig, setLayoutConfig] = useState<LayoutConfig>({
        ripple: true,
        inputStyle: 'outlined',
        menuMode: 'static',
        menuTheme: localStorage.getItem('theme') || 'light',
        colorScheme: (localStorage.getItem('colorScheme') as ColorScheme) || 'light',//'light',
        scale: 14,
        menuProfilePosition: 'start',
        desktopMenuActive: true,
        mobileMenuActive: false,
        mobileTopbarActive: false,
        componentTheme: 'orange',
        topbarTheme: 'orange',
    });
     
    const [layoutState, setLayoutState] = useState<LayoutState>({
        staticMenuDesktopInactive: false,
        overlayMenuActive: false,
        configSidebarVisible: false,
        profileSidebarVisible: false,
        staticMenuMobileActive: false,
        menuHoverActive: false,
        rightMenuActive: false,
        topbarMenuActive: false,
        sidebarActive: false,
        anchored: false,
        overlaySubmenuActive: false,
        menuProfileActive: false,
        resetMenu: false
    });

    //  useEffect(() => {
    //     const theme ='theme-light/orange';
    //     const colorScheme = localStorage.getItem('colorScheme') || 'light';

    //     const themeLink = document.getElementById('theme-link') as HTMLLinkElement;
    //     if (themeLink) {
    //         themeLink.href = `/theme/${theme}/theme.css`;
    //     } else {
    //         const link = document.createElement('link');
    //         link.id = 'theme-link';
    //         link.rel = 'stylesheet';
    //         link.href = `/theme/${theme}/theme.css`;
    //         document.head.appendChild(link);
    //     }

    //     document.documentElement.setAttribute('data-theme', colorScheme);
    // }, []);

    const onMenuProfileToggle = () => {
        setLayoutState((prevLayoutState) => ({
            ...prevLayoutState,
            menuProfileActive: !prevLayoutState.menuProfileActive
        }));
    };

    const isSidebarActive = () => layoutState.overlayMenuActive || layoutState.staticMenuMobileActive || layoutState.overlaySubmenuActive;

    const onMenuToggle = () => {
        if (isOverlay()) {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                overlayMenuActive: !prevLayoutState.overlayMenuActive
            }));
        }

        if (isDesktop()) {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                staticMenuDesktopInactive: !prevLayoutState.staticMenuDesktopInactive
            }));
        } else {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                staticMenuMobileActive: !prevLayoutState.staticMenuMobileActive
            }));
        }
    };

    const isOverlay = () => {
        return layoutConfig.menuMode === 'overlay';
    };

    const isSlim = () => {
        return layoutConfig.menuMode === 'slim';
    };

    const isSlimPlus = () => {
        return layoutConfig.menuMode === 'slim-plus';
    };

    const isHorizontal = () => {
        return layoutConfig.menuMode === 'horizontal';
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };
    const onTopbarMenuToggle = () => {
        setLayoutState((prevLayoutState) => ({
            ...prevLayoutState,
            topbarMenuActive: !prevLayoutState.topbarMenuActive
        }));
    };
    const showRightSidebar = () => {
        setLayoutState((prevLayoutState) => ({
            ...prevLayoutState,
            rightMenuActive: true
        }));
    };

    const value = {
        layoutConfig,
        setLayoutConfig,
        layoutState,
        setLayoutState,
        onMenuToggle,
        isSlim,
        isSlimPlus,
        isHorizontal,
        isDesktop,
        isSidebarActive,
        breadcrumbs,
        setBreadcrumbs,
        onMenuProfileToggle,
        onTopbarMenuToggle,
        showRightSidebar
    };

    return (
        <LayoutContext.Provider value={value}>
            
            {props.children}
        </LayoutContext.Provider>
    );
};